<div class="upload-progress-overlay" *ngIf="state.visible">
  <!-- Backdrop -->
  <div class="overlay-backdrop" (click)="hasActiveUploads() ? null : onClose()"></div>

  <!-- Content Card -->
  <div class="overlay-content">
    <div class="overlay-card">
      <!-- Header -->
      <div class="overlay-header">
        <div class="header-icon">
          <app-icon type="upload" size="32" color="#667eea"></app-icon>
        </div>
        <h3 class="header-title">{{ state.title }}</h3>
        <p class="header-subtitle" *ngIf="state.subtitle">{{ state.subtitle }}</p>
      </div>

      <!-- Progress Section -->
      <div class="overlay-body">
        <!-- Overall Progress -->
        <div class="overall-progress">
          <div class="progress-info">
            <span class="progress-label">Progression globale</span>
            <span class="progress-value">
              {{ uploadService.getCompletedCount() }} / {{ state.tasks.length }}
            </span>
          </div>

          <div class="progress-bar-container">
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="state.totalProgress"></div>
            </div>
            <span class="progress-percentage">{{ state.totalProgress }}%</span>
          </div>

          <div class="progress-stats" *ngIf="getUploadInfo()">
            <span class="stats-text">{{ getUploadInfo() }}</span>
          </div>
        </div>

        <!-- Task List -->
        <div class="task-list">
          <div
            *ngFor="let task of state.tasks"
            class="task-item"
            [ngClass]="getStatusClass(task.status)">
            <div class="task-icon">
              <app-icon [type]="getStatusIcon(task.status)" size="20"></app-icon>
            </div>
            <div class="task-info">
              <div class="task-name">{{ task.name }}</div>
              <div class="task-progress" *ngIf="task.status === 'uploading' && task.size">
                <div class="task-progress-bar">
                  <div class="task-progress-fill" [style.width.%]="task.progress"></div>
                </div>
              </div>
            </div>
            <div class="task-status">
              <span class="status-text">{{ getStatusLabel(task) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="overlay-footer">
        <button
          *ngIf="hasActiveUploads() && state.canCancel"
          class="btn-cancel"
          (click)="onCancel()">
          <app-icon type="close" size="16"></app-icon>
          Annuler
        </button>
        <button
          *ngIf="!hasActiveUploads()"
          class="btn-close"
          (click)="onClose()">
          Fermer
        </button>
      </div>
    </div>
  </div>
</div>
